const { resolveWarehouseByLocationId } = require('../../order/tools/read/warehouse-code-to-virtual')

module.exports = {
  getWarehouseOriginIdForUser
}

function getWarehouseOriginIdForUser (user = {}) {
  const location = user.location || {}
  const { id: locationId, level: locationLevel } = location
  const userRoles = Array.isArray(user.roles) ? user.roles : []
  const isWarehouseUser = userRoles.some(role => role.includes('userRole:psm-warehouse'))

  if (!isWarehouseUser || !locationId || locationLevel !== 'zone') {
    return null
  }

  try {
    return resolveWarehouseByLocationId(locationId, null)._id
  } catch (error) {
    return locationId
  }
}
